"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _style = require("./style");

var _index = _interopRequireDefault(require("../Icon/index"));

var _palette = require("../../../styles/palette");

var Advantage = function Advantage(_ref) {
  var title = _ref.title,
      text = _ref.text,
      icon = _ref.icon,
      colorIcon = _ref.colorIcon,
      colorText = _ref.colorText,
      top = _ref.top;
  return _react["default"].createElement(_style.Container, {
    "data-test-id": "advantage"
  }, icon && _react["default"].createElement(_index["default"], {
    icon: icon,
    color: colorIcon,
    size: 40
  }), _react["default"].createElement(_style.TextContainer, null, title && _react["default"].createElement(_style.Title, {
    color: colorText
  }, title), text && _react["default"].createElement(_style.Text, {
    color: colorText,
    top: top,
    "data-title": !!title
  }, text)));
};

Advantage.propTypes = {
  colorIcon: _propTypes["default"].string,
  colorText: _propTypes["default"].string,
  icon: _propTypes["default"].string.isRequired,
  text: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  top: _propTypes["default"].bool
};
Advantage.defaultProps = {
  colorIcon: _palette.palette.bobBlack.toString(),
  colorText: _palette.palette.bobBlack.toString(),
  title: null,
  top: false
};
var _default = Advantage;
exports["default"] = _default;